<!-- Sales Assistant switcher: hidden entirely unless the user can act as other agents AND
     has at least one assignable agent (or is mid-impersonation, so Exit stays reachable). -->
<div class="agent-switcher" *ngIf="canAccess && (agents?.length || acting)">
  <div class="dropdown">
    <button
      type="button"
      class="agent-switcher-btn"
      [class.acting]="acting"
      data-bs-toggle="dropdown"
      data-bs-auto-close="true"
      aria-expanded="false"
      [attr.aria-label]="acting ? 'Acting as ' + currentAgent?.full_name : 'Act as an agent'">
      <i class="pi pi-users agent-switcher-lead" aria-hidden="true"></i>
      <span class="agent-switcher-label">
        <ng-container *ngIf="acting; else notActing">
          Acting as <b>{{ currentAgent?.full_name }}</b>
        </ng-container>
        <ng-template #notActing>Select Agent</ng-template>
      </span>
      <i class="pi pi-angle-down agent-switcher-caret" aria-hidden="true"></i>
    </button>

    <div class="dropdown-menu dropdown-menu-right agent-switcher-menu">
      <div class="agent-switcher-title">Sales Assistant</div>

      <div *ngIf="!agents?.length" class="agent-switcher-empty">No agents assigned to you yet.</div>

      <button
        *ngFor="let agent of agents"
        type="button"
        class="agent-switcher-item"
        [class.active]="isCurrent(agent)"
        [class.awaiting]="!isApproved(agent)"
        [disabled]="!isApproved(agent)"
        (click)="pick(agent)">
        <span class="agent-avatar">
          <span class="agent-avatar-initials">{{ initials(agent) }}</span>
          <img *ngIf="photoSrc(agent) as src" [src]="src" [alt]="agent.full_name || ''" (error)="onImgError($event)" />
        </span>
        <span class="agent-info">
          <span class="agent-name">{{ agent.full_name }}</span>
          <span class="agent-email" *ngIf="agent.email">{{ agent.email }}</span>
          <span class="agent-status" *ngIf="!isApproved(agent)">{{
            agent.access_status === 'revoked' ? 'Access revoked' : 'Awaiting approval'
          }}</span>
        </span>
      </button>

      <div class="agent-switcher-divider" *ngIf="acting"></div>
      <button *ngIf="acting" type="button" class="agent-switcher-exit" (click)="exit()">
        <i class="pi pi-sign-out" aria-hidden="true"></i>
        <span>Exit Agent View</span>
      </button>
    </div>
  </div>
</div>
